import { render, staticRenderFns } from "./FollowCode.vue?vue&type=template&id=4c6f4bb9&scoped=true&"
import script from "./FollowCode.vue?vue&type=script&lang=js&"
export * from "./FollowCode.vue?vue&type=script&lang=js&"
import style0 from "./FollowCode.vue?vue&type=style&index=0&id=4c6f4bb9&lang=less&scoped=true&"
import style1 from "./FollowCode.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6f4bb9",
  null
  
)

export default component.exports